// extracted by mini-css-extract-plugin
export var isHidden = "sliderPageLogo-module--isHidden--bd1fb";
export var logoCtn = "sliderPageLogo-module--logoCtn--490ea";
export var logoLink = "sliderPageLogo-module--logoLink--79e99";